import React from 'react';
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*styles */
import useStyles from '../../styles';

/*components */
import AssetTransferTable from './Components/AssetTransferTable';

export default function Position(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Partial - Asset Transfer
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <span color="inherit">ACATS</span>
            <Typography color="primary">Partial</Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <AssetTransferTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
